import { ArrowBackRounded } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";

import { eboStoreExpensesServices } from "./data";
import ExpensesDashboard from "./ExpensesDashboard";

function EboStoreExpenses() {
	const navigate = useNavigate();
	const [currentPath, service] = useOutletContext();

	const tabComponents = {
		[eboStoreExpensesServices.masters.types.dashboard.key]: {
			...eboStoreExpensesServices.masters.types.dashboard,
			component: <ExpensesDashboard />,
		},
	};

	return (
		<Box width={"100%"} p={1}>
			<Box display="flex" alignItems="center" columnGap={1} mt={2}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Typography variant="h5">{service?.name}</Typography>
			</Box>
			{tabComponents?.[currentPath]?.component}
		</Box>
	);
}

export default EboStoreExpenses;
